<template>
  <div
    v-if="loaded"
    class="grossingTabSample"
  >
    <b-row class="d-flex align-items-center mb-2 mt-1">
      <b-col>
        <span class="ap-title ap-title__main">
          {{ $tc('diagnosis.sections.sampleInfo') }}
        </span>
      </b-col>
      <b-col
        cols="auto"
        class="d-flex justify-content-end"
      >
        <div>
          <b-button
            id="pop-label"
            v-tooltip="$tc('global.tags')"
            qa="sample-processing-tab-sample-tags-button"
            class="btn__icon btn__icon--primary  px-2"
            style="position:relative"
          >
            <i
              class="fas fa-send-backward"
              aria-hidden="true"
            />
            <vtBubble
              class="tag-indicator"
              :number="internalSample.tags.length"
              info
            />
          </b-button>
          <b-popover
            target="pop-label"
            title="Popover"
            placement="bottom"
            triggers="click blur"
          >
            <div class="pop-labels ap-popover">
              <div class="pop-labels-container">
                <b-form-checkbox-group
                  v-model="internalSample.tags"
                >
                  <div
                    v-for="tag in sampleTags"
                    :key="tag.id"
                    class="pop-labels-row bottom-bordered d-flex justify-content-between py-2 px-1"
                  >
                    <div class="pl-2">
                      <i
                        class="fas fa-square ml-1 mr-2"
                        :style="`color: ${tag.color}`"
                        aria-hidden="true"
                      />
                      <span>{{ tag.name }}</span>
                    </div>
                    <b-form-checkbox
                      qa="sample-processing-tab-sample-tag-checkbox"
                      :class="{'disabled':disabledTagsEdition}"
                      :disabled="disabledTagsEdition"
                      :value="tag"
                    />
                  </div>
                </b-form-checkbox-group>
              </div>
            </div>
          </b-popover>
          <!-- TODO: Comment for future development -->
          <!--<b-button qa="sample-processing-tab-sample-shipments-button"
                    class="btn__icon btn__icon--primary px-2"
                    v-tooltip="$tc('shipments.actions.checkToSend')"
                    v-if="canCreateShipmentRequests()"
                    @click="$refs.itemsForShippingModal.show()">
            <i class="far fa-box" aria-hidden="true"/>
          </b-button>-->
          <b-button
            v-if="visibleSampleOperations"
            id="sample-more"
            qa="sample-processing-tab-sample-ellipsis-button"
            class="btn__icon btn__icon--primary  px-2"
          >
            <i
              class="fas fa-ellipsis-v"
              aria-hidden="true"
            />
          </b-button>
          <b-popover
            v-if="visibleSampleOperations"
            target="sample-more"
            placement="bottom"
            triggers="click blur"
          >
            <div class="ap-popover">
              <ul>
                <li
                  v-if="$_canCreateIncident()"
                >
                  <b-button
                    qa="sample-processing-tab-sample-add-incident-button"
                    :disabled="!$_canBeIncidentCreatedToSample(internalSample)"
                    @click="$emit('openIncidentFormModal', {casId: caseId, samId: sampleId})"
                  >
                    {{ $tc('diagnosis.btns.incident') }}
                  </b-button>
                </li>
                <li
                  v-if="$_canAttachDocumentToSample()"
                >
                  <b-button
                    qa="sample-processing-tab-sample-add-attachment-button"
                    :disabled="!sampleId || !$_canBeDocumentAttachedToSample(internalSample)"
                    @click="showSampleAttachmentModal"
                  >
                    {{ $tc('diagnosis.btns.attach') }}
                  </b-button>
                </li>
                <li v-if="internalSample.label">
                  <b-button
                    qa="sample-processing-tab-sample-show-in-global-locator-button"
                    @click="showInGlobalLocator(internalSample.label)"
                  >
                    {{ $tc('global.showInGlobalLocator') }}
                  </b-button>
                </li>
              </ul>
            </div>
          </b-popover>
          <!-- TODO: El botón de +Submuestra de momento se oculta por órdenes de Javier hasta nuevo aviso, no borrar el siguiente comentario -->
          <!-- <b-button
              v-if="!internalSample.parentSampleSamId"
              class="btn-primary ml-2"
              size="sm"
              :disabled="!isEditableCase(caseStudy && caseStudy.status.code)"
              @click="$emit('creatingSubsampleMode')"
            >
              <i class="fal fa-plus mr-2"  aria-hidden="true"/>
              {{ $tc('global.subsample') }}
            </b-button> -->
        </div>
      </b-col>
    </b-row>
    <b-row v-if="laboratoryIdSample !== laboratoryId">
      <b-col>
        <alert-banner
          :variant="'info'"
          :text="`${$tc('global.elementLocatedIn')} ${internalSample.currentLaboratory.labName}`"
        />
      </b-col>
    </b-row>

    <!--Sample Data-->
    <b-row>
      <b-col>
        <div class="form-card">
          <b-row class="mb-2">
            <b-col class="d-flex align-items-center">
              <span class="ap-title ap-title__section">
                <i
                  class="far fa-list-ul mr-2"
                  aria-hidden="true"
                />
                {{ internalSample.label ? internalSample.label : $tc('grossing.content.new') }}
              </span>
              <div
                v-if="!partialEmbedding"
                class="ml-3"
              >
                <span class="depleted-text"><i
                  class="far fa-empty-set mr-1"
                  aria-hidden="true"
                />{{ $tc('global.depletedSample') }}</span>
              </div>
            </b-col>
          </b-row>

          <b-form>
            <b-row class="mb-2">
              <b-col
                xl="3"
                lg="5"
                md="6"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('component.samplesModal.local') + ' *' }}
                  </label>
                </div>
                <vt-combo-select
                  v-model="internalSample.topographicCode"
                  v-validate="'required'"
                  qa="sample-processing-tab-sample-topographic-code-select"
                  :option-loader="getTopographicCode"
                  :allow-empty="false"
                  track-by="id"
                  value-key="id"
                  label="description"
                  data-vv-name="grossingTopographicCode"
                  class="nowrap"
                  :class="{ requiredform: (showErrors && !internalSample.topographicCode) }"
                  :disabled="$_disabledTopographicCode(internalSample)"
                />
              </b-col>
              <b-col
                xl="3"
                lg="5"
                md="6"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('component.samplesModal.type') + ' *' }}
                  </label>
                </div>
                <vt-combo-select
                  id="sampleType"
                  v-model="internalSample.sampleType"
                  v-validate="'required'"
                  qa="sample-processing-tab-sample-type-select"
                  track-by="id"
                  :option-loader="getSampleTypes"
                  :allow-empty="false"
                  label="description"
                  :value-ajax="internalSample.sampleType"
                  data-vv-name="grossingSampleType"
                  :disabled="$_disabledSampleType(internalSample)"
                  :class="{ requiredform: (showErrors && (!internalSample.sampleType || !internalSample.sampleType.id)) }"
                  @input="changeSelectedSampleType"
                />
              </b-col>
              <b-col
                v-if="routeIsGrossing"
                xl="1"
                lg="2"
                md="3"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('component.samplesModal.frag') }}
                  </label>
                </div>
                <vt-input
                  id="fraginput"
                  v-model="internalSample.fragments"
                  qa="sample-processing-tab-sample-fragments-input"
                  type="number"
                  class="form-control-sm"
                  :disabled="isReadOnly"
                />
              </b-col>
              <b-col
                lg="5"
                md="9"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('grossing.content.procedure') }}
                  </label>
                </div>
                <vt-combo-select
                  id="procedureId"
                  v-model="internalSample.procedure"
                  qa="sample-processing-tab-sample-procedure-select"
                  track-by="id"
                  class="nowrap"
                  :option-loader="getProcedures"
                  label="description"
                  :disabled="$_disabledProcedure(internalSample)"
                />
              </b-col>
              <b-col
                cols="12"
                xl="2"
                md
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ routeIsGrossing ? $tc('grossing.sidebar.grossingDate') : $tc('laboratory.cytology.processingDate') }}
                  </label>
                </div>
                <vt-date-picker
                  qa="sample-processing-tab-sample-last-grossing-date"
                  :model="internalSample.lastGrossingDate"
                  disabled
                />
              </b-col>
              <b-col
                cols="12"
                xl="2"
                md
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('grossing.content.obtainingDate') }}
                  </label>
                </div>
                <vt-date-picker
                  qa="sample-processing-tab-sample-sampling-date"
                  :model="internalSample.samplingDate"
                  disabled
                />
              </b-col>
              <b-col
                v-if="routeIsGrossing"
                xl="4"
                lg="6"
              >
                <b-form-row>
                  <b-col
                    md="6"
                    class="mb-2"
                  >
                    <div class="form-label">
                      <label>{{ $tc('grossing.content.process') }}
                      </label>
                    </div>
                    <vt-combo-select
                      v-model="internalSample.sampleProcess"
                      qa="sample-processing-tab-sample-process-select"
                      class="nowrap process-multiselect"
                      track-by="id"
                      :option-loader="getProcess"
                      value-key="id"
                      label="name"
                      :disabled="isReadOnly || isSampleProcessed"
                    />
                  </b-col>
                  <b-col
                    v-if="routeIsGrossing"
                    md="6"
                    class="mb-2"
                  >
                    <div class="form-label">
                      <label>{{ $tc('grossing.content.noticeDate') }}
                      </label>
                    </div>
                    <vt-date-picker
                      qa="sample-processing-tab-sample-notice-date"
                      :model="internalSample.sampleProcessTargetDate"
                      :not-before="new Date()"
                      :disabled="!internalSample.sampleProcess || isReadOnly"
                      @update="internalSample.sampleProcessTargetDate = $event"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
              <b-col
                v-if="routeIsGrossing"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('grossing.sidebar.shelf', 1) }}
                  </label>
                </div>
                <vt-combo-select
                  v-model="internalSample.virtualShelf"
                  qa="sample-processing-tab-sample-shelf-select"
                  track-by="id"
                  :option-loader="getVirtualShelves"
                  value-key="id"
                  label="name"
                  :disabled="shelfChangeDisabled"
                />
              </b-col>
              <b-col
                v-if="routeIsGrossing"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('grossing.labels.differentFixer') }}
                  </label>
                </div>
                <vt-combo-select
                  v-model="internalSample.fixer"
                  qa="sample-processing-tab-sample-fixers-select"
                  track-by="id"
                  :option-loader="getFixers"
                  value-key="id"
                  label="name"
                  :disabled="isReadOnly"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <div class="form-label">
                  <label>{{ $tc('global.observations') }}
                  </label>
                </div>
                <b-form-textarea
                  v-if="sampleObservations"
                  v-model="sampleObservations.text"
                  qa="sample-processing-tab-sample-observations-textarea"
                  class="mb-2 ob-textarea"
                  max-rows="2"
                  rows="2"
                  :disabled="isReadOnly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col
                v-if="routeIsGrossing"
                xl="2"
                lg="4"
                md="6"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('grossing.content.until') }}
                  </label>
                </div>
                <vt-date-picker
                  qa="sample-processing-tab-sample-grossing-delay-date"
                  :disabled="$_disabledGrossingDelay(internalSample) || !routeIsGrossing"
                  :not-before="new Date()"
                  :model="internalSample.grossingDelay"
                  @update="internalSample.grossingDelay = $event"
                />
              </b-col>
              <b-col
                cols="auto"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ routeIsGrossing ? $tc('grossing.content.partial') : $tc('laboratory.cytology.partialProcessing') }}
                  </label>
                </div>
                <div class="d-flex">
                  <div class="col-3 switch-btn p-0">
                    <input
                      id="toggle"
                      v-model="partialEmbedding"
                      type="checkbox"
                      class="offscreen"
                      :disabled="$_disabledDepleted(internalSample)"
                      aria-hidden="true"
                      @change="onPartialEmbeddingToggled()"
                    >
                    <label
                      qa="sample-processing-tab-sample-partial-embedding-switch-label"
                      for="toggle"
                      class="switch"
                    />
                  </div>
                </div>
              </b-col>
              <b-col
                v-if="partialEmbedding"
                xl="auto"
                lg
                md="6"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('grossing.content.specialPreserved') }}
                  </label>
                </div>
                <div class="d-flex align-items-center">
                  <b-form-group
                    size="sm"
                    class="mb-0"
                  >
                    <b-form-radio-group
                      v-model="selectedSpecialPreserveOption"
                      qa="sample-processing-tab-sample-special-preserve-options"
                      :options="specialPreserveOptions"
                      buttons
                      button-variant="outline-primary"
                      size="sm"
                      name="radio-btn__outline"
                      class="btn__group"
                      :disabled="isReadOnly"
                      @change="onSpecialPreserveChanged($event)"
                    />
                  </b-form-group>
                </div>
              </b-col>
              <b-col
                v-if="partialEmbedding"
                lg="3"
                xl="2"
                md="6"
              >
                <div class="form-label">
                  <label>{{ $tc('grossing.content.preservedDays') }}
                  </label>
                </div>
                <vt-input
                  v-validate="daysToPreserveValidator"
                  :value="internalSample.daysBeforeDisposal"
                  qa="sample-processing-tab-sample-days-to-preserve-input"
                  :name="$tc('grossing.content.preservedDays')"
                  :disabled="disabledDaysToPreserveSelection"
                  type="number"
                  :min="selectedSampleTypeLaboratoryDetails.defaultDaysBeforeDisposal"
                  class="form-control-sm"
                  :class="{ requiredform: (showErrors && validPartialEmbedding) }"
                  @change="onDaysToPreserveChanged($event.target.value)"
                />
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-col>
    </b-row>

    <!--People Data-->
    <b-row class="mt-3">
      <b-col>
        <div class="form-card">
          <span class="ap-title ap-title__section">
            <i
              class="far fa-user-friends mr-2"
              aria-hidden="true"
            />
            {{ $tc('grossing.content.people') }}
          </span>

          <b-form class="mt-2">
            <b-row>
              <b-col
                xl="3"
                lg="4"
                md="6"
                class="mb-2"
              >
                <div class="form-label d-flex">
                  <label>{{ routeIsGrossing ? $tc('component.samplesModal.grossingResponsible') : $tc('laboratory.form.processResponsable') }}
                    <i
                      v-if="internalSample.automaticGrossingResponsible"
                      v-tooltip="$tc('global.automaticAssignment')"
                      class="fal fa-magic ml-1"
                      aria-hidden="true"
                    />
                  </label>
                  <b-button
                    v-tooltip="routeIsGrossing ? $tc('grossing.modal.grossingResponsible', 2) : $tc('laboratory.form.processResponsable')"
                    class="btn__icon btn__icon--primary p-0 pr-0"
                    style="margin-right: 0 !important"
                    @click="$refs.grossingResponsiblesModal.show()"
                  >
                    <i
                      class="far fa-info-circle"
                      aria-hidden="true"
                    />
                  </b-button>
                </div>
                <vt-combo-select
                  id="grossingResponsible"
                  v-model="internalSample.grossingResponsible"
                  qa="sample-processing-tab-sample-grossing-responsible-select"
                  class="nowrap"
                  track-by="id"
                  :option-loader="getPersonnelGrossingResponsible"
                  value-key="id"
                  label="fullName"
                  :disabled="$_disabledGrossingResponsible(internalSample)"
                />
              </b-col>
              <b-col
                xl="3"
                lg="4"
                md="6"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ routeIsGrossing ? $tc('component.samplesModal.controlResponsible') : $tc('laboratory.form.processTechnician') }}
                  </label>
                </div>
                <vt-combo-select
                  v-model="internalSample.grossingTechController"
                  qa="sample-processing-tab-sample-grossing-controller-select"
                  class="nowrap"
                  track-by="id"
                  label="fullName"
                  value-key="id"
                  :option-loader="getPersonnelGrossingControllers"
                  :disabled="$_disabledGrossingTechController(internalSample)"
                />
              </b-col>
              <b-col
                xl="3"
                lg="4"
                md="6"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ routeIsGrossing ? $tc('component.samplesModal.grossingTutor') : $tc('laboratory.form.processTutor') }}
                  </label>
                </div>
                <vt-combo-select
                  v-model="internalSample.grossingTutor"
                  qa="sample-processing-tab-sample-grossing-tutor-select"
                  class="nowrap"
                  track-by="id"
                  label="fullName"
                  value-key="id"
                  :option-loader="getPersonnelGrossingTutors"
                  :disabled="$_disabledGrossingTutor(internalSample)"
                />
              </b-col>
              <b-col
                xl="3"
                lg="4"
                md="6"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ routeIsGrossing ? $tc('component.samplesModal.grossingCoordinator') : $tc('laboratory.form.processCoordinator') }}
                  </label>
                </div>
                <vt-combo-select
                  v-model="internalSample.grossingCoordinator"
                  qa="sample-processing-tab-sample-grossing-coordinator-select"
                  :open-direction="'top'"
                  class="nowrap"
                  track-by="id"
                  label="fullName"
                  value-key="id"
                  :option-loader="getPersonnelGrossingCoordinators"
                  :disabled="$_disabledGrossingCoordinator(internalSample)"
                />
              </b-col>
              <b-col
                v-if="routeIsLaboratory"
                xl="3"
                lg="4"
                md="6"
                class="mb-2"
              >
                <div class="form-label">
                  <label>{{ $tc('component.samplesModal.specialist') }}
                    <i
                      v-if="internalSample.automaticSpecialist"
                      v-tooltip="$tc('global.automaticAssignment')"
                      class="fal fa-magic ml-1"
                      aria-hidden="true"
                    />
                  </label>
                </div>
                <vt-combo-select
                  v-model="internalSample.specialist"
                  qa="sample-processing-tab-sample-specialist-select"
                  :open-direction="'top'"
                  class="nowrap"
                  track-by="id"
                  label="fullName"
                  value-key="id"
                  :option-loader="getPersonnelCytologyExpert"
                  :disabled="$_disabledSpecialist(internalSample)"
                />
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-col>
    </b-row>

    <!--Modals-->
    <samples-update-util ref="samplesUpdateUtil" />
    <modal-wrapper ref="addFileModalWrapper">
      <add-file-modal
        id="addFileModal"
        ref="addFileModal"
        :attachment-entity-type="ATTACHMENT_ENTITY_TYPE"
        :entities-id-array="entitiesIdArray"
        @attachmentsAdded="onAttachmentsAdded()"
      />
    </modal-wrapper>
    <modal-grossing-responsible-list
      ref="grossingResponsiblesModal"
      :laboratory-id="laboratoryId"
      :case-id="caseId"
      :sample-id="sampleId"
    />
    <modal-wrapper ref="itemsForShippingModal">
      <items-for-shipping-modal
        :samples="[internalSample]"
        :cas-id="caseId"
        :lab-id="laboratoryId"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import { commonSampleProcessService } from '@/api/resources/common/sample-process/sample-process.service'
import sampleProcessingVirtualShelvesService
    from '@/modules/sampleProcessingModule/services/sampleProcessingVirtualShelvesService'
import sampleProcessingFixerService from '@/modules/sampleProcessingModule/services/sampleProcessingFixerService'
import { cloneDeep, isEqual } from 'lodash'
import SamplesUpdateUtil from '@/components/common/SamplesUpdateUtil'
import sampleAttachmentService from '@/api/resources/attachment/sampleAttachmentService'
import AddFileModal from '@/components/AddFileModal'
import sampleTypeLaboratoryService from '@/api/resources/sampleTypeLaboratoryService'
import sampleTagService from '@/api/resources/sampleTagService'
import { personnelService } from '@/api/resources/personnelService'
import { RESPONSIBILITIES } from '@/api/resources/responsibilityService'
import sessionStore from '@/session/sessionStore'
import { SAMPLE_STATES } from '@/api/resources/entityState/sample-state'
import ModalGrossingResponsibleList
    from '@/modules/sampleProcessingModule/views/form/modals/ModalGrossingResponsibleList'
import ItemsForShippingModal from '@/modules/shipments-module/old/views/components/ItemsForShippingModal'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { SAMPLE_TYPE_WORKFLOW } from '@/api/resources/common/commonSampleService'
import sampleObservationsService from '@/api/resources/clob/SampleObservationsService'
import sampleProcessingSampleService from '@/modules/sampleProcessingModule/services/sampleProcessingSampleService'
import VtBubble from '@/components/common/VtBubble'
import { CaseOperationGuardMixin } from '@/api/operations/mixins/guards/case-operation-guard.mixin'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'
import { ShipmentOperationGuardMixin } from '@/api/operations/mixins/guards/shipment-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import AlertBanner from '@/components/common/AlertBanner/alert-banner.vue'

const PRESERVE_OPTION_NO = 'no'
const PRESERVE_OPTION_INDEFINITE = 'indefinite'
const PRESERVE_OPTION_DAYS = 'days'

export default {
    name: 'SampleProcessingTabSample',
    components: {
        SamplesUpdateUtil,
        AddFileModal,
        ModalGrossingResponsibleList,
        ItemsForShippingModal,
        VtBubble,
        AlertBanner
    },
    mixins: [
        CaseOperationGuardMixin,
        SampleOperationGuardMixin,
        ShipmentOperationGuardMixin,
        IncidentOperationGuardMixin
    ],
    props: {
        disabled: { type: Boolean, default: false },
        laboratoryId: { type: Number, required: true },
        caseStudy: { type: Object, required: true },
        sample: { type: Object, required: true },
        routeIsGrossing: { type: Boolean },
        routeIsLaboratory: { type: Boolean }
    },
    data() {
        return {
            loaded: false,
            elementsToSend: [],
            selected: null,
            selectedAudio: null,
            hideAudio: true,
            grossingResponsibles: [],
            showErrors: false,
            internalSample: cloneDeep(this.sample),
            refreshEditor: 0,
            creatingSubsampleMode: false,
            selectedSampleTypeLaboratoryDetails: null,
            selectedSpecialPreserveOption: null,
            specialPreserveOptions: [
                { text: this.$tc('grossing.content.presOptionNo'), value: PRESERVE_OPTION_NO },
                { text: this.$tc('grossing.content.presOptionIndefinite'), value: PRESERVE_OPTION_INDEFINITE },
                { text: this.$tc('grossing.content.presOptionDays'), value: PRESERVE_OPTION_DAYS }
            ],
            partialEmbedding: false,
            daysToPreserve: null,
            sampleTags: [],
            sampleObservationsOriginal: {},
            sampleObservations: {}
        }
    },
    computed: {
        caseId() { return this.caseStudy.id },
        caseTypeId() { return this.caseStudy.caseType.id },
        sampleId() { return this.sample.id },

        SAMPLE_TYPE_WORKFLOW() {
            return SAMPLE_TYPE_WORKFLOW
        },
        ATTACHMENT_ENTITY_TYPE() {
            return ATTACHMENT_ENTITY_TYPE.SAMPLE
        },
        PRESERVE_OPTION_DAYS() {
            return PRESERVE_OPTION_DAYS
        },
        laboratoryIdRegistered() {
            return this.caseStudy.laboratory.labId
        },
        laboratoryIdSample() {
            return this.internalSample.currentLaboratory.labId
        },
        validPartialEmbedding() {
            return (this.daysToPreserve < this.selectedSampleTypeLaboratoryDetails.defaultDaysBeforeDisposal) &&
                this.selectedSpecialPreserveOption === PRESERVE_OPTION_DAYS
        },
        entitiesIdArray() {
            return [this.laboratoryId, this.caseId, this.sampleId]
        },
        shelfChangeDisabled() {
            return this.isReadOnly || ![SAMPLE_STATES.REGISTERED.code, SAMPLE_STATES.REPROCESSING_REQUESTED.code].includes(this.internalSample?.status?.code)
        },
        daysToPreserveValidator() {
            return 'min_value:' + this.selectedSampleTypeLaboratoryDetails.defaultDaysBeforeDisposal
        },
        selectedAudioRecordingUrl() {
            return this.selectedAudio ? this.generateUrlForAttachment(this.selectedAudio.attachmentId) : ''
        },
        isReadOnly() {
            return this.disabled || !this.$_canEditSample()
        },
        sampleCanBeProcessed() {
            return !this.$_isCaseValidated(this.caseStudy?.status.code) && this.isSamplePendingGrossing
        },
        isSamplePendingGrossing() {
            return [SAMPLE_STATES.REGISTERED.code, SAMPLE_STATES.REPROCESSING_REQUESTED.code, SAMPLE_STATES.IN_PROCESSOR.code].includes(this.sample?.status?.code)
        },
        isSampleProcessed() {
            return this.internalSample?.status?.code === SAMPLE_STATES.PROCESSED.code
        },
        disabledDaysToPreserveSelection() {
            return this.isReadOnly || this.selectedSpecialPreserveOption !== PRESERVE_OPTION_DAYS
        },
        disabledTagsEdition() {
            return !this.$_canEditSample()
        },
        visibleSampleOperations() {
            return this.$_canCreateIncident() ||
                this.$_canAttachDocumentToSample()
        }
    },
    watch: {
        async sample() {
            await Promise.all([
                this.loadSampleTags(),
                this.loadSample()
            ])
        }
    },
    async created() {
        await Promise.all([
            this.loadSampleTags(),
            this.loadSample()
        ])
    },
    methods: {
        showInGlobalLocator(label) {
            this.$eventHub.$emit('show-in-global-locator', label)
        },
        onPartialEmbeddingToggled() {
            this.internalSample.isDepleted = !this.partialEmbedding
            if (this.internalSample.isDepleted) {
                this.internalSample.specialPreserve = false
                this.internalSample.daysBeforeDisposal = null
            } else if (this.selectedSpecialPreserveOption === PRESERVE_OPTION_NO) {
                this.internalSample.daysBeforeDisposal = this.selectedSampleTypeLaboratoryDetails.defaultDaysBeforeDisposal
            }
        },
        onSpecialPreserveChanged(newValue) {
            switch (newValue) {
            case PRESERVE_OPTION_NO:
                this.internalSample.specialPreserve = false
                this.internalSample.daysBeforeDisposal = this.selectedSampleTypeLaboratoryDetails.defaultDaysBeforeDisposal
                break
            case PRESERVE_OPTION_INDEFINITE:
                this.internalSample.specialPreserve = true
                this.internalSample.daysBeforeDisposal = null
                break
            case PRESERVE_OPTION_DAYS:
                this.internalSample.specialPreserve = true
                this.internalSample.daysBeforeDisposal = this.daysToPreserve || this.selectedSampleTypeLaboratoryDetails.defaultDaysBeforeDisposal
                break
            }
        },
        onDaysToPreserveChanged(newValue) {
            this.daysToPreserve = newValue
            this.internalSample.daysBeforeDisposal = newValue
        },
        getProcedures() {
            return commonSampleClassificationService.getCommonProceduresSampleClassificationsByLaboratory(
                { laboratoryId: this.laboratoryIdSample })
        },
        getProcess() {
            return commonSampleProcessService.getCommonSampleProcess()
        },
        getTopographicCode() {
            return commonSampleClassificationService.getCommonTopographicCodesSampleClassificationsByLaboratory(
                { laboratoryId: this.laboratoryIdSample })
        },
        getSampleTypes() {
            return commonSampleClassificationService.getCommonSampleTypeSampleClassificationsByLaboratory(
                {
                    laboratoryId: this.laboratoryIdSample,
                    caseTypeIds: [this.caseTypeId]
                })
        },
        getVirtualShelves() {
            return sampleProcessingVirtualShelvesService.getVirtualShelvesByLaboratoryId(this.laboratoryIdSample)
        },
        getFixers() {
            if (this.internalSample.sampleType) {
                return sampleProcessingFixerService.getSampleFixers(this.laboratoryIdSample, this.internalSample.sampleType.id)
            }
            return []
        },
        async loadSample() {
            this.internalSample = cloneDeep(this.sample)
            await this.loadSampleObservations()
            await this.applyPostSampleLoadingChanges()
            this.loaded = true
        },
        async loadSampleObservations() {
            const [err, response] = await this.toCall(sampleObservationsService.findById(this.laboratoryId, this.caseId, this.sampleId))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.sampleObservationsOriginal = response
            this.sampleObservations = cloneDeep(this.sampleObservationsOriginal)
        },
        async applyPostSampleLoadingChanges() {
            await this.loadSampleTypeLaboratoryDetails()
            this.partialEmbedding = !this.internalSample.isDepleted
            if (this.internalSample.specialPreserve) {
                this.daysToPreserve = this.internalSample.daysBeforeDisposal
                if (this.internalSample.daysBeforeDisposal) {
                    this.selectedSpecialPreserveOption = PRESERVE_OPTION_DAYS
                } else {
                    this.selectedSpecialPreserveOption = PRESERVE_OPTION_INDEFINITE
                }
            } else {
                this.selectedSpecialPreserveOption = PRESERVE_OPTION_NO
                this.daysToPreserve = this.internalSample.daysBeforeDisposal || this.selectedSampleTypeLaboratoryDetails.defaultDaysBeforeDisposal
            }
        },
        async changeSelectedSampleType(newSampleType) {
            this.internalSample.sampleType = newSampleType
            if (newSampleType) {
                await this.loadSampleTypeLaboratoryDetails()
                if (this.partialEmbedding && this.selectedSpecialPreserveOption === PRESERVE_OPTION_NO) {
                    this.daysToPreserve = this.selectedSampleTypeLaboratoryDetails.defaultDaysBeforeDisposal
                }
            }
        },
        hasBeenChanged() {
            const internalSample = this.removeExternalOptionFromEntityObjects(this.internalSample)
            const originalSample = this.removeExternalOptionFromEntityObjects(this.sample)
            const sampleChanged = !isEqual(originalSample, internalSample)

            const sampleObservations = this.removeExternalOptionFromEntityObjects(this.sampleObservations)
            const originalSampleObservations = this.removeExternalOptionFromEntityObjects(this.sampleObservationsOriginal)
            const sampleObservationsChanged = !isEqual(originalSampleObservations, sampleObservations)

            return sampleChanged || sampleObservationsChanged
        },
        async saveSampleObservations() {
            this.updateLoading(true)
            const observation = {
                text: this.sampleObservations.text,
                originalConcurrencyUpdatedAt: this.sampleObservations.originalConcurrencyUpdatedAt
            }
            const [err] = await this.toCall(sampleObservationsService.update(this.laboratoryId, this.caseId, this.sampleId, observation))
            this.updateLoading(false)
            if (err) {
                if (err.response?.data?.code === this.$apiExceptions.CONCURRENCY_ERROR) {
                    return this.processBasicConcurrencyConflict(this.$tc('diagnosis.sections.observations'), err, () => {
                        this.sampleObservations.originalConcurrencyUpdatedAt = err.response.data.currentConcurrencyUpdatedAt
                        return this.saveSampleObservations()
                    })
                } else {
                    this.showErrorModalGlobal()
                    return false
                }
            } else {
                return true
            }
        },
        async save() {
            if (!this.hasBeenChanged()) {
                return true
            }

            this.showErrors = false
            if (!await this.validateSample()) {
                return false
            }

            this.updateLoading(true)
            let updatedSample, updatedSampleObservations
            if (this.$_isCaseValidated(this.caseStudy?.status.code)) {
                const [err] = await this.toCall(
                    sampleTagService.updateTagsOfSample(
                        this.laboratoryId, this.caseId, this.sampleId, this.internalSample.tags?.flatMap(tag => tag.id)))
                if (err) {
                    this.updateLoading(false)
                    this.showErrorModalGlobal()
                    return false
                }
                updatedSample = true
            } else {
                const sampleToUpdate = this.createRequestFromSampleValues()
                updatedSample = await this.$refs.samplesUpdateUtil.updateSample(
                    this.laboratoryId, this.caseId, this.sampleId, sampleToUpdate, sampleProcessingSampleService)
                updatedSampleObservations = await this.saveSampleObservations()
            }
            this.updateLoading(false)

            if (updatedSample != null && (updatedSampleObservations || updatedSampleObservations === undefined)) {
                this.showToastSuccessGlobal()
                this.$emit('sample-changed', this.internalSample)
                return true
            }
            return false
        },
        isResponsibleForGrossingValid() {
            return sessionStore.getUserPersonnelId() === this.internalSample.grossingResponsible?.id
        },
        createRequestFromSampleValues() {
            return {
                caseId: this.caseId,
                sampleId: this.sampleId,
                topographicCodeId: this.internalSample.topographicCode?.id ?? null,
                sampleTypeId: this.internalSample.sampleType?.id ?? null,
                procedureId: this.internalSample.procedure?.id ?? null,
                fragments: this.internalSample.fragments,
                sampleProcessId: this.internalSample.sampleProcess?.id ?? null,
                sampleProcessTargetDate: this.internalSample.sampleProcess ? this.internalSample.sampleProcessTargetDate : null,
                partialEmbedding: this.partialEmbedding,
                daysBeforeDisposal: this.internalSample.daysBeforeDisposal,
                specialPreserve: this.internalSample.specialPreserve,
                fixerId: this.internalSample.fixer?.id ?? null,
                virtualShelfId: this.internalSample.virtualShelf?.id ?? null,
                parentSampleSamId: this.internalSample.parentSampleSamId,
                sampleTagIds: this.internalSample.tags?.flatMap(tag => tag.id),
                grossingResponsibleId: this.internalSample.grossingResponsible?.id ?? null,
                grossingTechControllerId: this.internalSample.grossingTechController?.id ?? null,
                grossingTutorId: this.internalSample.grossingTutor?.id ?? null,
                grossingCoordinatorId: this.internalSample.grossingCoordinator?.id ?? null,
                specialistId: this.internalSample.specialist?.id ?? null,
                originalConcurrencyUpdatedAt: this.internalSample.originalConcurrencyUpdatedAt,
                grossingDelay: this.internalSample.grossingDelay
            }
        },
        generateUrlForAttachment(attachmentId) {
            return sampleAttachmentService.getUrlForAttachment(this.laboratoryId, this.caseId, this.sampleId, attachmentId)
        },
        showSampleAttachmentModal() {
            this.$refs.addFileModalWrapper.show()
        },
        async onAttachmentsAdded(attachments) {
            if (!attachments) {
                this.internalSample.attachments = []
            } else {
                this.internalSample.attachments.push(attachments)
            }
            this.$emit('sample-attachment-added', this.internalSample.samId)
        },
        addSubsample() {
            this.creatingSubsampleMode = true
            this.partialEmbedding = false
            this.internalSample = cloneDeep(this.sample)
        },
        isSubsample() {
            return this.internalSample?.parentSampleSamId
        },
        async saveNewSubsample() {
            this.showErrors = false
            if (!await this.validateSample()) {
                return
            }

            this.updateLoading(true)
            const sampleToCreate = this.createRequestFromSampleValues()
            const [error, response] = await this.toCall(sampleProcessingSampleService.createSubsampleBatch(this.laboratoryId, this.caseId, [sampleToCreate]))
            if (error) {
                this.updateLoading(false)
                this.showErrorModalGlobal()
                return
            }

            const createdSample = response.data[0]
            if (createdSample != null) {
                this.$router.push({
                    name: 'grossingSampleView',
                    params: {
                        casId: this.caseId,
                        samId: createdSample.samId
                    }
                })
            }
            this.updateLoading(false)
        },
        async validateSample() {
            const formValidation = await this.$validator.validate()
            if (!formValidation) {
                this.showErrors = true
                const preservedDaysErr = await this.$validator.errors.items?.find(
                    error => error.field === this.$tc('grossing.content.preservedDays'))
                this.showErrorModalGlobal(preservedDaysErr?.msg || this.$tc('studyRequest.general.requiredFieldsNotice'))
            }
            return formValidation
        },
        async loadSampleTypeLaboratoryDetails() {
            const [error, response] = await this.toCall(
                sampleTypeLaboratoryService.findSampleTypeLaboratoryBySampleTypeId(
                    this.laboratoryIdSample,
                    this.internalSample.sampleType.id))
            if (error) {
                this.showErrorModalGlobal(this.$tc('grossing.error.loadingSampleTypeLaboratoryDetails'))
            } else {
                this.selectedSampleTypeLaboratoryDetails = response
            }
        },
        async loadSampleTags() {
            const [error, response] = await this.toCall(sampleTagService.findAllActiveForLaboratory(this.laboratoryIdRegistered))
            if (error) {
                this.showErrorModalGlobal(this.$tc('grossing.error.loadingSampleTags'))
            } else {
                this.sampleTags = response
            }
        },
        getPersonnelGrossingResponsible() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(
                this.laboratoryIdSample,
                this.routeIsGrossing
                    ? RESPONSIBILITIES.GROSSING_RESPONSIBLE
                    : RESPONSIBILITIES.PROCESSING_RESPONSIBLE)
        },
        getPersonnelGrossingControllers() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(
                this.laboratoryIdSample,
                this.routeIsGrossing
                    ? RESPONSIBILITIES.GROSSING_CONTROLLER
                    : RESPONSIBILITIES.PROCESSING_CONTROLLER)
        },
        getPersonnelGrossingTutors() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(
                this.laboratoryIdSample,
                this.routeIsGrossing
                    ? RESPONSIBILITIES.GROSSING_TUTOR
                    : RESPONSIBILITIES.PROCESSING_TUTOR)
        },
        getPersonnelGrossingCoordinators() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(
                this.laboratoryIdSample,
                this.routeIsGrossing
                    ? RESPONSIBILITIES.GROSSING_COORDINATOR
                    : RESPONSIBILITIES.PROCESSING_COORDINATOR)
        },
        getPersonnelCytologyExpert() {
            return personnelService.getPersonnelByLaboratoryAndResponsibility(
                this.laboratoryIdSample,
                RESPONSIBILITIES.CYTOLOGY_EXPERT)
        }
    }
}
</script>

<style lang="scss">

.grossingTabSample .process-multiselect .multiselect__content-wrapper {
  min-width: 250px;
}

.grossingTabSample .btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active, .btn-group-vertical > .btn:focus, .btn-group-vertical > .btn:active, .btn-group-vertical > .btn.active {
  background: vt-color(primary);
  color: vt-color(white-light);
}

.grossingTabSample .multiselect__tags {
  overflow: hidden;
}

.grossingTabSample .vt-date-picker {
  padding-right: 0 !important;
}

.grossingTabSample .grossing-custom-breakpoint {
    .bp-50 {
        @media only screen and (max-width: bp(tablet-wide)) and (min-width: bp(tablet-medium)) {
            background: yellow;
            max-width: 50%;
            flex: 0 0 50%;
        }
    }
    .bp-100 {
        @media only screen and (max-width: bp(tablet-wide)) and (min-width: bp(tablet-medium)) {
            background: yellow;
            max-width: 100%;
            flex: 0 0 100%;
        }
    }

}

</style>

<style lang="scss" scoped>

.pop-labels {
  width: 200px;
}

.labels-btn {
  background: transparent;
  color: vt-color(primary);
  border-color: transparent;
  margin: 0;
}

.label-bubble {
  background: vt-color(primary);
  color: vt-color(white-light);
  border-radius: 50%;
  width: 15px;
  height: 15px;
}

.pop-label-btn {
  background: transparent;
  color: #212529;
  border-color: transparent;
  padding: 0;
  font-size: 0.875rem;
}

.no-visible {
  display: none;
}

h4 {
  font-weight: normal;
}

.labelColor {
  height: 26px;
  width: 26px;
  border-radius: 3px;
  margin-left: 2px;
}

.labelDifferent {
  background: #fbb03b;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  transition: all 0.3s;
  cursor: pointer;
}

.switch::after {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 18px;
  background-color: white;
  top: 1px;
  left: 1px;
  transition: all 0.3s;
}

input[type='checkbox']:checked + .switch::after {
  transform: translateX(20px);
}

input[type='checkbox']:checked + .switch {
  background-color: vt-color(primary);
}

.offscreen {
  position: absolute;
  left: -9999px;
}

.description-btns i {
  font-size: 1.1rem !important;
}

.tags-btn {
  margin-right: 0 !important;
}

.tags-btn span {
  font-size: font-size(very-small);
}

.tag-indicator {
    position: absolute;
    right: -5px;
    top: 12px;
}

</style>
